module.exports = __webpack_public_path__ + "img/jersey.f12e5dce.svg";